import { SITE } from "@/lib/site";
import { contactPhoto, contactPhotoAlt } from "@/components/contactPhoto";
import { SplitSection } from "@/components/SplitSection";

export function ContactSection() {
  return (
    <SplitSection
      id="contact"
      image={contactPhoto}
      imageAlt={contactPhotoAlt}
      imageSide="left"
      title="Bring Somo to your property"
      body="See how Somo can create a better experience for your guests, your operations, and your bottom line."
      cta={{ label: "Let’s Talk", href: `${SITE}/contact` }}
    />
  );
}
